export default __webpack_public_path__ + "static/media/phone-icon-secondary-color.0f0310d7.svg";